import { getFacilityIdAndOriginToken } from 'utils/TokenHelpers';
import { getMyOrigin } from 'utils/origin';
import { getTestEnvHeadersForProxyServer } from '../../utils/utils';

export const facilityId = process.env.GATSBY_FACILITY_ID ?? '';
export const cookieExpiryTime = process.env.GATSBY_COOKIE_EXPIRY_TIME ?? '';
export const accountRoute = 'account';
export const accountSelectionRoute = 'account-selection';

const origin = getMyOrigin();
const isValidValue = (value: any) => value !== undefined && value !== null && value !== '';

export const getFacilityId = (facilityId: any) => {
  if (isValidValue(facilityId)) {
    return facilityId;
  }
  return process.env.GATSBY_FACILITY_ID || '';
};

export const getCustomHeaders = (facilitySMSId: any) => {
  return {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    Authorization: 'Bearer ' + getFacilityIdAndOriginToken(getFacilityId(facilitySMSId), origin),
    ...getTestEnvHeadersForProxyServer(),
  };
};
